import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.hp.lytech.jp/' 
  : 'http://localhost:3000';

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 未授权，清除token并跳转到登录页
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 登录API
export const login = (userData) => {
  return api.post('/login', userData);
};

// 新闻API
export const newsApi = {
  // 获取新闻列表
  getList: (params) => {
    return api.get('/news', { params });
  },
  
  // 获取单个新闻
  getById: (id) => {
    return api.get(`/news/${id}`);
  },
  
  // 创建新闻
  create: (data) => {
    return api.post('/news', data);
  },
  
  // 更新新闻
  update: (id, data) => {
    return api.patch(`/news/${id}`, data);
  },
  
  // 删除新闻
  delete: (id) => {
    return api.delete(`/news/${id}`);
  }
};

// Measure News API
export const measureNewsApi = {
  // 获取 Measure News 列表
  getList: (params) => {
    return api.get('/measure-news', { params });
  },
  
  // 获取单个 Measure News
  getById: (id) => {
    return api.get(`/measure-news/${id}`);
  },
  
  // 创建 Measure News
  create: (data) => {
    return api.post('/measure-news', data);
  },
  
  // 更新 Measure News
  update: (id, data) => {
    return api.patch(`/measure-news/${id}`, data);
  },
  
  // 删除 Measure News
  delete: (id) => {
    return api.delete(`/measure-news/${id}`);
  }
};

// 博客API
export const blogsApi = {
  // 获取博客列表
  getList: (params) => {
    return api.get('/blogs', { params });
  },
  
  // 获取单个博客
  getById: (id) => {
    return api.get(`/blogs/${id}`);
  },
  
  // 创建博客
  create: (data) => {
    return api.post('/blogs', data);
  },
  
  // 更新博客
  update: (id, data) => {
    return api.patch(`/blogs/${id}`, data);
  },
  
  // 删除博客
  delete: (id) => {
    return api.delete(`/blogs/${id}`);
  }
};

// 个人资料API
export const personalsApi = {
  // 获取个人资料列表
  getList: (params) => {
    return api.get('/personals', { params });
  },
  
  // 获取单个个人资料
  getById: (id) => {
    return api.get(`/personals/${id}`);
  },
  
  // 创建个人资料
  create: (data) => {
    return api.post('/personals', data);
  },
  
  // 更新个人资料
  update: (id, data) => {
    return api.patch(`/personals/${id}`, data);
  },
  
  // 删除个人资料
  delete: (id) => {
    return api.delete(`/personals/${id}`);
  }
};

// 上传API
export const uploadApi = {
  // 上传图片
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
};

export default api;
